import React from 'react';
import './App.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { MenuUnificadoRouterDay } from './router/MenuUnificadoRouterDay';
import { MenuUnificadoRouterNight } from './router/MenuUnificadoRouterNight';

function App() {
  // CRA DefinePlugin replaces this at build time so Terser eliminates the dead branch
  if (process.env.REACT_APP_MENU_MODE === 'night') {
    // eslint-disable-next-line react/jsx-no-undef
    return <MenuUnificadoRouterNight />;
  }
  // eslint-disable-next-line react/jsx-no-undef
  return <MenuUnificadoRouterDay />;
}

export default App;
